//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';
import styled from "styled-components";

import { login, logout, checkIfUserIsAuthenticated } from '../actions/UserActions';
import { BlankAlert } from './ChangePasswordForm';
import { Heading2, IRISBlueDivider, TextRouteLink, } from './Common/SharedStyledComponents';
import { IrisColors } from '../css/IRISColors';

const Login = () => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [statusMessage, setStatusMessage] = useState("");

    const userIsAuthenticated = useSelector(state => state.userProperties.isAuthenticated);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(logout());
    }, []);

    const handleLoginFormSubmit = () => {
        if (username === "") {
            setStatusMessage("Username cannot be empty.");
            return;
        }

        if (password === "") {
            setStatusMessage("Password cannot be empty.");
            return;
        }
        checkIfUserIsAuthenticated(username, password).then(function (userfound) {
            if (userfound["isAuthenticated"] == 1) {
                dispatch(login(username, password));
            }
            else {
                setStatusMessage("Invalid credentials. Please try again");
            }
        });
        setUsername("");
        setPassword("");
    }

    return (
        <div className="wrapper">
            <LoginFrom>
                <div>
                    <Heading2 color={IrisColors.irisLogoBlue} bold center >IRIS Member Portal Sign In</Heading2>
                    <IRISBlueDivider />
                </div>
                <div>
                    <label htmlFor="username" >User ID</label>
                    <input
                        id="username"
                        type="text"
                        className="form-control"
                        name="username"
                        value={username}
                        placeholder="User ID"
                        onChange={(event) => {
                            setUsername(event.target.value);
                            setStatusMessage("");
                        }}
                    />
                </div>
                <div>
                    <label htmlFor="password" >Password</label>
                    <input
                        id="password"
                        type="password"
                        className="form-control"
                        name="password"
                        value={password}
                        placeholder="Password"
                        onChange={(event) => {
                            setPassword(event.target.value);
                            setStatusMessage("");
                        }}
                    />
                </div>
                <button className="btn btn-lg btn-primary btn-block" type="button" onClick={() => handleLoginFormSubmit()}>Sign In</button>
                <label className="terms">
                    By clicking Sign In, you agree to the IRIS Terms of Use, and Privacy Statement.
                </label>
                {
                    statusMessage
                        ? <Alert bsStyle="danger" className="in">
                            <Alert.Heading>
                                {statusMessage}
                            </Alert.Heading>
                        </Alert>
                        : <BlankAlert />
                }
                <TextRouteLink to="/forgot-password">Forgot your password?</TextRouteLink>
            </LoginFrom>
        </div>
    );
}

const LoginFrom = styled.form`
    display: grid;
    grid-gap: 1.5rem;
    min-height: 420px;
    max-width: 420px;
    padding: 25px;
    margin: 0 auto;
    margin-top: 60%;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.1);
    font-weight: normal;
    color: #00658a;
    font-size: 15px;
`;

export default Login;